<router-outlet>

<!--  <p>{{'s'|translate}}</p>-->
<!--  <p (click)="changeLanguage('fa-ir')">فارسی</p>-->
<!--  <p  (click)="changeLanguage('en-us')">en</p>-->


</router-outlet>


